
import { useState } from "react";
import "./ReviewComponent.css";

import { FaStar } from "react-icons/fa";


const ReviewComponent = (props) => {

  //Props
  const Rating = props.Rating || 0;
  const SetRating = props.SetRating;
  const ReadOnly = props.ReadOnly;

  const [hover, setHover] = useState(0);


  return (
    <div className="review_cont">
      <div className="review_rating_cont">
        {[...Array(5)].map((s, index) => 
          <div className={"review_star " + (ReadOnly ? "" : "review_star_active")}
            style={{ color: (index + 1 <= (hover || Rating) ? "#ffc107" : "#e4e5e9")}}
            onClick={() => ReadOnly ? undefined : SetRating(index + 1)}
            onMouseEnter={() => ReadOnly ? undefined : setHover(index + 1)}
            onMouseLeave={() => ReadOnly ? undefined : setHover(0)}
            key={index}
            >
            <FaStar size={36}
            />
          </div>
        )}
      </div>
    </div>
  )
}


export default ReviewComponent;